export enum WorkerType {
  EMPLOYEE = 1,
  FREELANCE = 2,
  RETIRED = 3,
}
